import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import "./HouseType.css";

const url = process.env.REACT_APP_BACKEND_URL;

const EditHouseType = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [name, setName] = useState("");

  useEffect(() => {
    const fetchHouseType = async () => {
      try {
        const res = await axios.get(`${url}/api/housetype/${id}`);
        setName(res.data.data.name);
      } catch (error) {
        toast.error("Failed to load house type details");
        navigate("/ViewHouseType");
      } finally {
        setLoading(false);
      }
    };
    fetchHouseType();
  }, [id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error("House type name is required");
      return;
    }

    setSubmitting(true);

    try {
      const res = await axios.put(`${url}/api/housetype/${id}`, { name: name.trim() });
      if (res.data.success) {
        toast.success("House type updated successfully!");
        navigate("/ViewHouseType");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update house type");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading">Loading house type...</div>;

  return (
    <div className="district-container">
      <div className="header">
        <h2>Edit House Type</h2>
        <button onClick={() => navigate("/ViewHouseType")} className="add-button">
          Back to List
        </button>
      </div>

      <form className="district-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>House Type Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter house type name"
            required
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={submitting}>
            {submitting ? "Updating..." : "Update House Type"}
          </button>
          <button
            type="button"
            onClick={() => navigate("/ViewHouseType")}
            className="cancel-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditHouseType;